import React, { useState } from 'react';
import { Tabs } from 'antd';
import UploadAwardsApproval from './UploadAwardsApproval';

const RewardsFinalApprovalUpload: React.FC = () => {
  const [activeKey, setActiveKey] = useState('1');

  const onTabChange = (key: string) => {
    setActiveKey(key);
  };

  return (
    <Tabs activeKey={activeKey} onChange={onTabChange}>
      <Tabs.TabPane tab="Approvals mass upload" key="1">
        <UploadAwardsApproval />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default RewardsFinalApprovalUpload;